<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.create_service") }}</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <formWrapper :validator="$v.form">
        <v-form @submit.prevent="handleSubmit">
          <v-row>
            <v-col
              v-if="$route.name === 'edit_service'"
              cols="12"
              md="6"
              class="mx-auto"
            >
              <locale-select v-model="locale" @change="changeLocale" />
            </v-col>
            <v-col cols="12">
              <span class="headings gray--text">{{
                $t("labels.required_image")
              }}</span>
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.main_image ? form.main_image.path : ''"
                :imgId="form.main_image ? form.main_image.id : ''"
                @fileSelected="handleMainImage"
                :maxSize="main_image_Size"
              />
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="name" attribute="fields.name">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.name"
                    outlined
                  >
                  </v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="priority" attribute="fields.priority">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.priority"
                    outlined
                  >
                  </v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group
                name="short_description"
                attribute="fields.short_description"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-textarea
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.short_description"
                    outlined
                    no-resize
                    rows="8"
                  >
                  </v-textarea>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="description" attribute="fields.description">
                <template slot-scope="{ attrs, listeners }">
                  <v-textarea
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.description"
                    outlined
                    no-resize
                    rows="8"
                  >
                  </v-textarea>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12">
              <section class="file-upload__gallery mt-2">
                <multi-image-upload
                  class="file-upload__gallery--upload"
                  :maxSize="photo_size"
                  @fileSelected="handleMultiPhotos"
                  @handle_delete_image="handleDelteImag"
                  :imgsUrl="form.media"
                />
              </section>
            </v-col>
          </v-row>
          <v-btn
            type="submit"
            :loading="loading"
            :disabled="$v.form.$invalid"
            class="primary"
          >
            <span>{{ $t("button.save") }}</span>
            <v-icon small right>mdi-send</v-icon>
          </v-btn>
        </v-form>
      </formWrapper>
    </v-container>
  </main>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate";
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
export default {
  name: "FormAction",
  data() {
    return {
      form: {
        name: "",
        description: "",
        short_description: "",
        priority: "",
        main_image: "",
        photos: []
      },
      main_image_Size: 2.48,
      photo_size: 1.24,
      locale: this.locale,
      loading: false
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50)
      },
      description: {
        required,
        minLength: minLength(3),
        maxWords: maxWords(500)
      },
      short_description: {
        required,
        minLength: minLength(3),
        maxWords: maxWords(50)
      },
      priority: {
        required,
        numeric
      },
      main_image: {
        required
      }
    }
  },
  methods: {
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },
    handleMainImage(img) {
      this.form.main_image = img.file;
    },
    handleMultiPhotos(photos) {
      this.form.photos = photos;
    },
    handleDelteImag(index) {
      this.form.media.splice(index, 1);
    },
    handleSubmit() {
      this.loading = true;
      const formData = new FormData();
      if (this.$route.name === "edit") {
        delete this.form.main_image;
      }
      Object.keys(this.form).forEach(key => {
        if (key !== "photos" && key !== "media") {
          formData.append(key, this.form[key]);
        }
      });
      this.form["photos"].length > 0 &&
        this.form["photos"].forEach(photo =>
          formData.append("photos[]", photo)
        );
      formData.append("locale", this.locale);

      if (this.$route.name === "create_service") {
        // in case create
        this.createSerivce(formData);
      } else {
        // in case edit
        formData.append("_method", "put");
        this.editService(formData);
      }
    },
    async createSerivce(data) {
      try {
        await StoreData({ reqName: "services", data });
        this.$router.push({ name: "services" });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editService(data) {
      const { slug } = this.$route.params;
      UpdateData({ reqName: "services", data, param: slug })
        .then(() => this.$router.push({ name: "services" }))
        .finally(() => (this.loading = false));
    },
    handleShowData(locale) {
      const { slug } = this.$route.params;

      if (slug) {
        ShowData({ reqName: "services", param: slug, locale }).then(res => {
          const { service } = res.data;
          this.form = {
            ...this.form,
            ...service
          };
          console.log(service);
        });
      }
    }
  },
  watch: {
    $route: {
      handler() {
        this.handleShowData();
      },
      immediate: true
    }
  }
};
</script>
